import {useEffect, useState} from 'react';
import {
  TwitchExtensionConfiguration,
  usePulsoidClient,
} from '../../PulsoidClient';
import css from './TwitchExtensionConfiguration.module.scss';
import {TwitchExtensionStreamDelayComponent} from './TwitchExtensionStreamDelayComponent';
import {TwitchExtensionVisibilityComponent} from './TwitchExtensionVisibilityComponent';
import {TwitchExtensionWidgetSelectorComponent} from './TwitchExtensionWidgetSelectorComponent';

export const TwitchExtensionConfigurationComponent = () => {
  let client = usePulsoidClient();
  let [loading, setLoading] = useState<boolean>(true);
  let [configuration, setConfiguration] =
    useState<TwitchExtensionConfiguration | null>(null);

  useEffect(() => {
    async function fetchData() {
      let response = await client.getTwitchExtensionConfiguration();
      setConfiguration(response.configuration);
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className={css.root}>
      <h1 className={css.header}>Twitch Extension Configuration</h1>
      <div className={css.content}>
        {configuration && (
          <TwitchExtensionStreamDelayComponent configuration={configuration} />
        )}

        {configuration && (
          <TwitchExtensionVisibilityComponent configuration={configuration} />
        )}

        {configuration && (
          <TwitchExtensionWidgetSelectorComponent
            configuration={configuration}
          />
        )}
      </div>
    </div>
  );
};

type StatusProps = {
  configuration: TwitchExtensionConfiguration | null;
  loading: boolean;
};

const TwitchExtensionConnectionStatus = (props: StatusProps) => {
  let badgeClass = props.configuration
    ? css.badge_connected
    : css.badge_not_connected;
  let badgeText = props.loading
    ? 'Loading...'
    : props.configuration
    ? 'Connected'
    : 'Not Connected';

  return (
    <div className={css.step}>
      <div>Twitch Extension Status</div>
      <div className={css.badge_container}>
        <div className={badgeClass}>{badgeText}</div>
      </div>
      <div>how to connect</div>
    </div>
  );
};

type TAStatus = {
  twitchConnected: boolean | null;
  twitchChannel: string | null;
  loading: boolean;
};

const TwitchAccountConnectionStatus = (props: TAStatus) => {
  let badgeClass = props.twitchConnected
    ? css.badge_connected
    : css.badge_not_connected;
  let badgeText = 'Loading...';
  if (props.twitchConnected != null) {
    if (props.twitchConnected) {
      badgeText = 'Connected';
    } else {
      badgeText = 'Not Connected';
    }
  }
  return (
    <div className={css.step}>
      <div>Twitch Account Connection</div>
      <div className={css.badge_container}>
        <div className={badgeClass}>{badgeText} </div>
      </div>
      <div>{props.twitchChannel}</div>
    </div>
  );
};
